export default __webpack_public_path__ + "static/media/oi_1.3054bd72.mp3";